import { REDUX_API_GATEWAY_ACTIONS } from '../constants/apiGateWayConstant';

// intiate store constant
import STORE_INITIATE_VALUE from '../constants/initialstore';

export default (state = STORE_INITIATE_VALUE.RELEVANT_REPORT, action) => {
  switch (action.type) {
    case REDUX_API_GATEWAY_ACTIONS.GET_REPORT_LINK_SUCCESS:
      if (action.payload === undefined || action.payload === null || Object.keys(action.payload).length === 0) {
        return {
          ...state,
          reportDetail: {},
        };
      }
      return {
        ...state,
        reportDetail: action.payload.data[0].attributes.Items[0],
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/reports.js